export default class ForListTestemunhosController {
    constructor($state, UIService, AuthenticationService, FormacaoService, FormacaoTestemunho, Funcionario, FormacaoCurso) {
        this.$state = $state;
        this.UI = UIService;
        this.FormacaoService = FormacaoService;
        this.FormacaoTestemunho = FormacaoTestemunho;
        this.Funcionario = Funcionario;
        this.FormacaoCurso = FormacaoCurso;
        this.user = AuthenticationService.getUser();
        this.dataLoaded = false;
        this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
        this.funcionarios = [];
        this.cursos = [];
        this.filtersLoaded = [1, 0, 0];
        this.opt = $state.params;
        // Default opt state - populate later when we have all states
        this.defaultOpt = {
            page: 1,
            items: 20,
            order: "id",
            sort: "desc",
            filter: undefined
        };
        this.displayColumns = [
            {
                displayName: 'ID SGI',
                name: 'id',
                visible: false,
                sortable: true
            },
            {
                displayName: 'Testemunho',
                name: 'designacao',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Autor',
                name: 'autor',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Data de Edição',
                name: 'dataCriacao',
                exportDate: 'DD-MM-YYYY',
                visible: false,
                sortable: true
            },
            {
                displayName: 'Editado por',
                name: 'colaborador',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Data de Testemunho',
                name: 'dataTestemunho',
                exportDate: 'DD-MM-YYYY',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Visível',
                name: 'visivel',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Curso',
                name: 'curso',
                visible: false,
                sortable: true
            }
        ];
        // type 's': select, 'o': plain text, 'd': date
        this.equalityFilters = [{
                val: 'a',
                name: 'Igual',
                type: 'o'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 'o'
            },
            {
                val: 'c',
                name: 'Começa por',
                type: 'o'
            },
            {
                val: 'd',
                name: 'Termina com',
                type: 'o'
            },
            {
                val: 'e',
                name: 'Contém',
                type: 'o'
            },
            {
                val: 'a',
                name: 'Igual (=)',
                type: 'd'
            },
            {
                val: 'b',
                name: 'Diferente de (≠)',
                type: 'd'
            },
            {
                val: 'c',
                name: 'Posterior a (>)',
                type: 'd'
            },
            {
                val: 'd',
                name: 'Anterior a (<)',
                type: 'd'
            },
            {
                val: 'e',
                name: 'Posterior ou igual (≥)',
                type: 'd'
            },
            {
                val: 'f',
                name: 'Anterior ou igual (≤)',
                type: 'd'
            },
            {
                val: 'a',
                name: 'Igual',
                type: 's'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 's'
            }
        ];
        this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');
        this.columns = [
            {
                id: 'FormacaoTestemunho.id',
                name: 'ID SGI',
                type: 'o'
            },
            {
                id: 'FormacaoTestemunho.designacao',
                name: 'Testemunho',
                type: 'o'
            },
            {
                id: 'FormacaoTestemunho.autor',
                name: 'Autor',
                type: 'o'
            },
            {
                id: 'FormacaoTestemunho.dataCriacao',
                name: 'Data de Edição',
                type: 'd',
                format: "YYYY-MM-DD",
                displayFormat: "DD/MM/YYYY"
            },
            {
                id: 'FormacaoTestemunho.funcionarioId',
                name: 'Editado por',
                type: 's',
                list: this.funcionarios
            },
            {
                id: 'FormacaoTestemunho.dataTestemunho',
                name: 'Data de Testemunho',
                type: 'd',
                format: "YYYY-MM-DD",
                displayFormat: "DD/MM/YYYY"
            },
            {
                id: 'FormacaoTestemunho.visivel',
                name: 'Visível',
                type: 's',
                list: this.simnao
            },
            {
                id: 'FormacaoTestemunho.cursoId',
                name: 'Curso',
                type: 's',
                list: this.cursos
            }
        ];
        // Find relevant displayColumns from local storage
        if (localStorage.getItem('ForTestemunhosDisplayColumns')) {
            let cols = JSON.parse(localStorage.getItem('ForTestemunhosDisplayColumns'));
            if (cols && cols.length > 0) {
                cols.forEach(c => {
                    let i = this.displayColumns.findIndex(x => x.name === c.name);
                    if (i >= 0)
                        this.displayColumns[i].visible = c.visible;
                });
            }
        }
        this.customFilters = [];
        // Find customFilters from local storage
        if (localStorage.getItem('ForTestemunhosFilter')) {
            this.customFilters = JSON.parse(localStorage.getItem('ForTestemunhosFilter'));
        }
        // Check if something comes from the URL, replace the customFilters if so
        if (this.opt.filter) {
            this.customFilters = [];
            let filters = this.opt.filter.split(":");
            filters.forEach(filter => {
                let a = filter.split("·");
                if (a.length === 3) {
                    try {
                        let data = {
                            column: {},
                            value: {}
                        };
                        data.column.selected = this.columns.find(f => {
                            return f.id === a[0];
                        });
                        if (angular.isUndefined(data.column.selected)) {
                            throw Error();
                        }
                        this.customFilters.push(data);
                    }
                    catch (e) {
                        this.customFilters = [];
                        this.UI.addToast('Não foi possível carregar filtros');
                    }
                }
            });
            // If updated, save it to local storage
            localStorage.setItem('ForTestemunhosFilter', JSON.stringify(this.customFilters));
        }
        // Restore list to selected if exists
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'FormacaoTestemunho.funcionarioId')
                    f.column.selected.list = this.funcionarios;
                if (f.column.selected.id === 'FormacaoTestemunho.visivel')
                    f.column.selected.list = this.simnao;
                if (f.column.selected.id === 'FormacaoTestemunho.cursoId')
                    f.column.selected.list = this.cursos;
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        // Number of selected items
        this.nSelected = 0;
        // Load the data for the filter panel (not mandatory just to look at the table)
        this.loadData();
        // Load the table data so we can see stuff even if nothing else works
        this.getTestemunhos();
    }
    clearFilter = () => {
        localStorage.removeItem('ForTestemunhosFilter');
        this.customFilters = [];
        this.getTestemunhos();
    };
    // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
    setWhereField = (data, whereObject, whereOrObject) => {
        // Check if have this entry in whereOr already
        if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
            whereOrObject.push({
                key: data.key,
                value: data.value
            });
        }
        else { // Not in OR, check if there's an entry of this key in whereObject already
            if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
                whereOrObject.push({
                    key: data.key,
                    value: whereObject[data.key]
                });
                delete whereObject[data.key];
                whereOrObject.push({
                    key: data.key,
                    value: data.value
                });
            }
            else { // It's the first entry of this key, use whereObject only
                whereObject[data.key] = data.value;
            }
        }
    };
    // Returns a whereFields object to use in table() remote methods (ativo, interacao)
    // WhereLiteral should be defined locally
    setWhereFields = (customFilters, literal, orsLiteral) => {
        let where = {};
        let whereDates = [];
        let whereNextDates = [];
        let whereLiteral = literal || {};
        let whereOrLiteral = orsLiteral || [];
        let whereOr = [];
        customFilters.forEach(f => {
            let data = {};
            data.key = f.column.selected.id;
            // Generated dates - Assuming if no . exists in field, it's always generated date
            if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
                whereNextDates.push({
                    key: data.key,
                    comp: f.values.selected.val,
                    value: f.value,
                    format: f.column.selected.format
                });
            }
            else { // All other cases where fields exist in database
                if (f.column.selected.type === 'o') {
                    data.value = f.value;
                    this.setWhereField(data, where, whereOr);
                }
                else {
                    if (f.column.selected.type === 'd') {
                        whereDates.push({
                            key: data.key,
                            comp: f.values.selected.val,
                            value: f.value,
                            format: f.column.selected.format
                        });
                    }
                    else {
                        // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
                        if (f.value.selected.id)
                            data.value = f.value.selected.id;
                        else
                            data.value = f.value.selected.value;
                        this.setWhereField(data, whereLiteral, whereOrLiteral);
                    }
                }
            }
        });
        return {
            where: where,
            whereDates: whereDates,
            whereNextDates: whereNextDates,
            whereLiteral: whereLiteral,
            whereOr: whereOr,
            whereOrLiteral: whereOrLiteral
        };
    };
    getTestemunhos = () => {
        this.tableLoading = true;
        let whereFields = this.setWhereFields(this.customFilters, {
            'FormacaoTestemunho.active': 1
        });
        this.FormacaoTestemunho.table({
            params: {
                fields: [
                    'FormacaoTestemunho.id as id',
                    'FormacaoTestemunho.designacao as designacao',
                    'FormacaoTestemunho.autor as autor',
                    'FormacaoTestemunho.dataCriacao as dataCriacao',
                    'Funcionario.name as colaborador',
                    'FormacaoTestemunho.dataTestemunho as dataTestemunho',
                    'FormacaoTestemunho.visivel as visivel',
                    'FormacaoTestemunho.cursoId as cursoId',
                    'FormacaoTestemunho.edicaoId as edicaoId',
                    'FormacaoCurso.designacao as curso'
                ],
                from: ['FormacaoTestemunho', 'Funcionario', 'FormacaoCurso'],
                referencesOrigin: [undefined, undefined, undefined],
                references: [undefined, 'FormacaoTestemunho.funcionarioId', 'FormacaoTestemunho.cursoId'],
                aliases: [],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                limit: this.opt.items,
                skip: (this.opt.page - 1) * this.opt.items
            }
        }).$promise.then(res => {
            let page = this.opt.page;
            let items = this.opt.items;
            let total = res.count;
            this.start = total > 0 ? (page - 1) * items + 1 : 0;
            if ((this.start - 1 + items) >= total) {
                this.end = total;
            }
            else {
                this.end = Number.parseInt(this.start - 1 + items);
            }
            // Process output
            // res.data.forEach(i => {
            // });
            this.testemunhos = res.data;
            this.total = total;
            this.allSelected = false;
            this.tableLoading = false;
        }).catch((error) => {
            this.UI.addToast("Não foi possível ler testemunhos. Verifique a ligação");
            console.log(error);
        });
    };
    exportTestemunhos = () => {
        let confirm = this.UI.showConfirm(`Tem a certeza que pretende exportar ${this.total === 1 ? (this.total + ' testemunho') : (this.total + ' testemunhos')}?`);
        confirm.then(() => {
            let wait = this.UI.showWaiting();
            let whereFields = this.setWhereFields(this.customFilters, { 'FormacaoTestemunho.active': 1 });
            this.FormacaoTestemunho.exportTestemunhos({
                displayColumns: this.displayColumns,
                params: {
                    fields: [
                        'FormacaoTestemunho.id as id',
                        'FormacaoTestemunho.designacao as designacao',
                        'FormacaoTestemunho.autor as autor',
                        'FormacaoTestemunho.dataCriacao as dataCriacao',
                        'Funcionario.name as colaborador',
                        'FormacaoTestemunho.dataTestemunho as dataTestemunho',
                        'FormacaoTestemunho.visivel as visivel',
                        'FormacaoCurso.designacao as curso'
                    ],
                    from: ['FormacaoTestemunho', 'Funcionario', 'FormacaoCurso'],
                    referencesOrigin: [undefined, undefined, undefined],
                    references: [undefined, 'FormacaoTestemunho.funcionarioId', 'FormacaoTestemunho.cursoId'],
                    aliases: [],
                    where: whereFields.where,
                    whereLiteral: whereFields.whereLiteral,
                    whereDates: whereFields.whereDates,
                    whereOr: whereFields.whereOr,
                    whereOrLiteral: whereFields.whereOrLiteral,
                    order: this.opt.order,
                    sort: this.opt.sort,
                    // limit: this.opt.items,
                    // skip: (this.opt.page - 1) * this.opt.items,
                }
            }).$promise.then(res => {
                if (res.count) {
                    wait.close();
                    let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                    let b = document.createElement('a');
                    b.href = url;
                    b.download = 'testemunhosExportados.xlsx';
                    b.click();
                }
                else {
                    this.UI.addToast("Nenhum resultado encontrado. A exportação foi cancelada.");
                }
            }).catch((e) => {
                wait.close();
                console.log(e);
                this.tableLoading = false;
                this.UI.addToast("Não foi possível exportar testemunhos. Verifique a ligação.");
            });
        }).catch(() => { });
    };
    exportSelected = () => {
        let wait = this.UI.showWaiting();
        let orsLiteral = [];
        // if a few amostras selected only
        if (this.hasSelect())
            orsLiteral = _.map(_.filter(this.testemunhos, x => x.selected), x => {
                return { key: 'FormacaoTestemunho.id', value: x.id };
            });
        let whereFields = this.setWhereFields(this.customFilters, { 'FormacaoTestemunho.active': 1 }, orsLiteral);
        this.FormacaoTestemunho.exportTestemunhos({
            displayColumns: this.displayColumns,
            params: {
                fields: [
                    'FormacaoTestemunho.id as id',
                    'FormacaoTestemunho.designacao as designacao',
                    'FormacaoTestemunho.autor as autor',
                    'FormacaoTestemunho.dataCriacao as dataCriacao',
                    'Funcionario.name as colaborador',
                    'FormacaoTestemunho.dataTestemunho as dataTestemunho',
                    'FormacaoTestemunho.visivel as visivel',
                    'FormacaoCurso.designacao as curso'
                ],
                from: ['FormacaoTestemunho', 'Funcionario', 'FormacaoCurso'],
                referencesOrigin: [undefined, undefined, undefined],
                references: [undefined, 'FormacaoTestemunho.funcionarioId', 'FormacaoTestemunho.cursoId'],
                aliases: [],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                // limit: this.opt.items,
                // skip: (this.opt.page - 1) * this.opt.items,
            }
        }).$promise.then(res => {
            if (res.count) {
                wait.close();
                let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                let b = document.createElement('a');
                b.href = url;
                b.download = 'testemunhosExportados.xlsx';
                b.click();
            }
            else {
                this.UI.addToast("Nenhum resultado encontrado. A exportação foi cancelada.");
            }
        }).catch((e) => {
            wait.close();
            console.log(e);
            this.tableLoading = false;
            this.UI.addToast("Não foi possível exportar testemunhos. Verifique a ligação.");
        });
    };
    isColumnVisible = (column) => {
        let f = this.displayColumns.find(x => x.name === column);
        return _.isEmpty(f) ? false : f.visible;
    };
    selectVisibleColumns = () => {
        let options = {
            size: 'md',
            template: require('./columns.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Editar Campos Visíveis";
                    scope.displayColumns = angular.copy(this.displayColumns);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.displayColumns) {
                this.displayColumns = angular.copy(res.displayColumns);
                // Save it to local storage
                localStorage.setItem('ForTestemunhosDisplayColumns', JSON.stringify(this.displayColumns));
            }
        });
    };
    loadData = () => {
        this.Funcionario.find({ filter: { where: { active: true }, order: 'name ASC' } }).$promise.then(funcionarios => {
            // funcionarios.forEach(t => {
            //   t.name = t.designacao;
            // });
            funcionarios.sort((a, b) => a.name.localeCompare(b.name));
            this.funcionarios = funcionarios;
            this.filtersLoaded[1] = 1;
        }).catch(err => {
            this.funcionarios = [];
            this.filtersLoaded[1] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Colaboradores).");
            console.log(err);
        });
        this.FormacaoCurso.find({ filter: { where: { active: true } } }).$promise.then(cursos => {
            cursos.forEach(t => {
                t.name = t.designacao;
            });
            cursos.sort((a, b) => a.name.localeCompare(b.name));
            this.cursos = cursos;
            this.filtersLoaded[2] = 1;
        }).catch(err => {
            this.cursos = [];
            this.filtersLoaded[2] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Cursos).");
            console.log(err);
        });
    };
    sort = key => {
        if (!key.sortable) {
            return;
        }
        let keyname = key.name;
        if (this.opt.order === keyname)
            this.opt.page = 1;
        this.opt.order = keyname;
        this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
        this.$state.go('app.formacao.testemunhos.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getTestemunhos();
    };
    item = val => {
        this.opt.items = val;
        this.$state.go('app.formacao.testemunhos.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getTestemunhos();
    };
    page = sum => {
        this.opt.page += sum;
        if (this.opt.page < 1)
            this.opt.page = 1;
        if (this.opt.page > Math.ceil(this.total / this.opt.items))
            this.opt.page = Math.ceil(this.total / this.opt.items);
        this.$state.go('app.formacao.testemunhos.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getTestemunhos();
    };
    openFilter = () => {
        let result = this.filtersLoaded.reduce((a, b) => a + b, 0);
        if (result !== this.filtersLoaded.length) {
            this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
            return;
        }
        if (!this.funcionarios.length) {
            this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
            return;
        }
        this.columns.forEach(f => {
            if (f.id === 'FormacaoTestemunho.funcionarioId')
                f.list = this.funcionarios;
            if (f.id === 'FormacaoTestemunho.visivel')
                f.list = this.simnao;
            if (f.id === 'FormacaoTestemunho.cursoId')
                f.list = this.cursos;
        });
        // Copy column to be used in
        this.editColumns = angular.copy(this.columns);
        // Restore list to selected
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'FormacaoTestemunho.funcionarioId')
                    f.column.selected.list = this.funcionarios;
                if (f.column.selected.id === 'FormacaoTestemunho.visivel')
                    f.column.selected.list = this.simnao;
                if (f.column.selected.id === 'FormacaoTestemunho.cursoId')
                    f.column.selected.list = this.cursos;
            }
        });
        // Copy customFilter to another variable so we can edit it all we want
        this.editCustomFilters = angular.copy(this.customFilters);
        // Show side panel
        this.fs = true;
    };
    oldColumn = ($item, i) => {
        //Infinite Scroll Magic
        i.infiniteScroll = {};
        i.infiniteScroll.numToAdd = 20;
        i.infiniteScroll.currentItems = 20;
        if ($item.type === 's')
            i.value = {};
        else
            i.value = "";
        i.addMoreItems = function () {
            i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
        };
    };
    applyFilter = () => {
        // Parse values from sidebar
        this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));
        // Remove list for column, no need to save it
        this.editCustomFilters.forEach(f => {
            if (f.column && f.column.selected) {
                f.column.selected.list = [];
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        this.customFilters = angular.copy(this.editCustomFilters);
        localStorage.setItem('ForTestemunhosFilter', JSON.stringify(this.customFilters));
        this.fs = false;
        // Go to first page for results
        this.opt.page = 1;
        this.$state.go('app.formacao.testemunhos.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getTestemunhos();
    };
    hasSelect = () => {
        return _.some(this.testemunhos, a => a.selected === true);
    };
    selectAll = () => {
        if (this.allSelected) { // Not all are selected, select all
            this.testemunhos.forEach(a => {
                a.selected = true;
            });
            this.nSelected = this.testemunhos.length;
        }
        else { // Remove all selections
            this.testemunhos.forEach(a => {
                a.selected = false;
            });
            this.nSelected = 0;
        }
    };
    selectItem = () => {
        this.nSelected = _.filter(this.testemunhos, r => r.selected).length;
        this.allSelected = this.nSelected >= this.testemunhos.length;
    };
    addTestemunho = () => {
        this.FormacaoCurso.find({
            fields: {
                id: true,
                designacao: true,
                active: true
            },
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((cursos) => {
            cursos.sort((a, b) => a.designacao.localeCompare(b.designacao));
            let options = {
                size: 'lg',
                template: require('./new.dialog.html'),
                controller: ['$dialog', '$scope', 'FormacaoEdicao', (dialog, scope, FormacaoEdicao) => {
                        // If Empresa is selected or not - used to fetch clientes
                        scope.title = "Adicionar Testemunho";
                        scope.cursos = cursos;
                        scope.loadingEdicoes = false;
                        scope.testemunho = {
                            visivel: false
                        };
                        scope.auxCurso = {
                            selected: undefined,
                            infiniteScroll: { numToAdd: 20, currentItems: 20 }
                        };
                        scope.onCursoSelected = (selected) => {
                            scope.auxEdicao.selected = undefined;
                            if (selected == null) { // Cleaned curso, clean edicao
                                scope.edicoes = [];
                            }
                            else { // Clean edicao if it's different Fetch new edicoes to select
                                scope.edicoes = [];
                                scope.loadingEdicoes = true;
                                FormacaoEdicao.find({
                                    filter: {
                                        where: {
                                            and: [{ active: 1 }, { cursoId: selected.id }]
                                        }
                                    }
                                }).$promise.then((edicoes) => {
                                    edicoes.forEach(e => e.designacao = `${e.no}/${e.ano}`);
                                    scope.loadingEdicoes = false;
                                    scope.edicoes = edicoes;
                                }).catch((error) => {
                                    scope.loadingEdicoes = false;
                                    this.UI.addToast("Erro na obtenção de Edições. Verifique a ligação");
                                    console.log(error);
                                    scope.edicoes = [];
                                });
                            }
                        };
                        scope.auxEdicao = {
                            selected: undefined,
                            infiniteScroll: { numToAdd: 20, currentItems: 20 }
                        };
                        //Infinite Scroll Magic
                        scope.addMoreItems = (infiniteScroll) => {
                            infiniteScroll.currentItems += infiniteScroll.numToAdd;
                        };
                        scope.ok = () => {
                            scope.testemunho.cursoId = scope.auxCurso.selected ? scope.auxCurso.selected.id : null;
                            scope.testemunho.edicaoId = scope.auxEdicao.selected ? scope.auxEdicao.selected.id : null;
                            dialog.close(scope.testemunho);
                        };
                        scope.cancel = () => {
                            dialog.dismiss('cancel');
                        };
                    }]
            };
            let modal = this.UI.showDialog(options);
            modal.then((ok) => {
                this.loaded = false;
                // Check for valid date in data de testemunho, otherwise null
                if (ok.dataTestemunho !== null && ok.dataTestemunho !== undefined && moment(ok.dataTestemunho).isValid()) {
                    ok.dataTestemunho = moment(ok.dataTestemunho).format();
                }
                else {
                    ok.dataTestemunho = null;
                }
                ok.id = 0;
                ok.funcionarioId = this.user.id;
                ok.dataCriacao = moment().format();
                ok.active = 1;
                this.FormacaoTestemunho.create(ok).$promise.then((res) => {
                    this.UI.addToast('Testemunho adicionado com sucesso');
                    this.getTestemunhos();
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na criação de testemunho. Verifique a ligação");
                });
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na obtenção de cursos. Verifique a ligação");
        });
    };
    editTestemunho = (testemunho) => {
        this.FormacaoCurso.find({
            fields: {
                id: true,
                designacao: true,
                active: true
            },
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((cursos) => {
            cursos.sort((a, b) => a.designacao.localeCompare(b.designacao));
            let options = {
                size: 'lg',
                template: require('./new.dialog.html'),
                controller: ['$dialog', '$scope', (dialog, scope) => {
                        // If Empresa is selected or not - used to fetch clientes
                        scope.title = "Editar Testemunho";
                        scope.cursos = cursos;
                        scope.testemunho = angular.copy(testemunho);
                        scope.testemunho.visivel = (scope.testemunho.visivel == 1);
                        scope.auxCurso = {
                            selected: cursos.find(f => f.id === testemunho.cursoId),
                            infiniteScroll: { numToAdd: 20, currentItems: 20 }
                        };
                        scope.auxEdicao = {
                            selected: undefined,
                            infiniteScroll: { numToAdd: 20, currentItems: 20 }
                        };
                        //Infinite Scroll Magic
                        scope.addMoreItems = (infiniteScroll) => {
                            infiniteScroll.currentItems += infiniteScroll.numToAdd;
                        };
                        scope.ok = () => {
                            scope.testemunho.cursoId = scope.auxCurso.selected ? scope.auxCurso.selected.id : null;
                            scope.testemunho.edicaoId = scope.auxEdicao.selected ? scope.auxEdicao.selected.id : null;
                            dialog.close(scope.testemunho);
                        };
                        scope.cancel = () => {
                            dialog.dismiss('cancel');
                        };
                    }]
            };
            let modal = this.UI.showDialog(options);
            modal.then((ok) => {
                this.loaded = false;
                // Check for valid date in data de testemunho, otherwise null
                if (ok.dataTestemunho !== null && ok.dataTestemunho !== undefined && moment(ok.dataTestemunho).isValid()) {
                    ok.dataTestemunho = moment(ok.dataTestemunho).format();
                }
                else {
                    ok.dataTestemunho = null;
                }
                ok.funcionarioId = this.user.id;
                ok.dataCriacao = moment().format();
                ok.active = 1;
                this.FormacaoTestemunho.upsert(ok).$promise.then((res) => {
                    this.UI.addToast('Testemunho editado com sucesso');
                    this.getTestemunhos();
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na criação de testemunho. Verifique a ligação");
                });
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na obtenção de cursos. Verifique a ligação");
        });
    };
    // If id, it's single, if nothing it's multiple and go through "selected"
    confirmRemoveTestemunhos = (id) => {
        let ids;
        if (id)
            ids = [id];
        else
            ids = this.testemunhos.map(x => { if (x.selected)
                return x.id; }).filter(x => x);
        if (ids.length === 0)
            return;
        if (ids.length > 20) {
            this.UI.showAlert("Não é possível remover mais de 20 testemunhos ao mesmo tempo.");
        }
        else {
            let plural = ids.length === 1 ? ` testemunho?` : `s ${ids.length} testemunhos?`;
            let confirm = this.UI.showConfirm("Tem a certeza que pretende remover este" + plural);
            confirm.then(() => {
                let wait = this.UI.showWaiting();
                this.FormacaoService.removeTestemunhos(ids).then(status => {
                    wait.close();
                    let errors = status.filter(x => x.error);
                    if (errors.length > 0) {
                        let title = "Erros de Remoção";
                        let introText = "Ocorreram os seguintes erros na remoção de testemunhos:";
                        let instance = this.UI.showDialog({
                            size: 'md',
                            template: require('../../../interface/modals/show-list.html'),
                            controller: ['$scope', ($scope) => {
                                    $scope.title = title;
                                    $scope.introText = introText;
                                    $scope.list = errors;
                                    $scope.ok = function () {
                                        $scope.$close();
                                    };
                                }]
                        });
                        instance.finally(() => {
                            this.getTestemunhos();
                        });
                    }
                    else {
                        if (ids.length === 1)
                            this.UI.addToast("Testemunho removido com sucesso");
                        else
                            this.UI.addToast("Testemunhos removidos com sucesso");
                        this.getTestemunhos();
                    }
                }).catch(error => {
                    wait.close();
                    console.log(error);
                    this.UI.showAlert("Erro na eliminação de testemunhos. Verifique a ligação");
                });
            });
        }
    };
}
ForListTestemunhosController.$inject = ['$state', 'UIService', 'AuthenticationService', 'FormacaoService', 'FormacaoTestemunho', 'Funcionario', 'FormacaoCurso'];
